import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import ChangePassword from './change-password';
import BlurModal from '../../components/common/blur-modal';


export default class NewUserChangePassword extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <BlurModal
         visible={true}
         doneVisible={false}
         >
         <ChangePassword source='resetpassword' />
       </BlurModal>
      );
  }
}
